
/* injects from baggage-loader */

'use strict';

import $ from 'jquery';

export default class StagePuzzleFormController {
    constructor($rootScope, $log, $element) {
        'ngInject';
        this.$log = $log;
        this.$element = $element;
        this.$rootScope = $rootScope;

        this.x = 0;
        this.y = 0;
        this.startY = 0;
        this.startX = 0;

        this.bindTouchEnd = this.touchEnd.bind(this)                
    }
    

    $onInit(){ 
        this.x = this.model.x;
        this.y = this.model.y;

        this.updateStyles();

        $(this.$element).find('> .puzzleform').on('mousedown', this.touchStart.bind(this));
        $(this.$element).find('> .puzzleform').on('touchstart', this.touchStart.bind(this));
    }

    touchStart(event){
        this.startX = event.screenX - this.x;
        this.startY = event.screenY - this.y;
        
        document.addEventListener('drop', this.bindTouchEnd, true);
    }
    
    touchEnd(event){
        let formsContainer = $(event.target).closest('.forms-container');

        if(formsContainer.length){
            // moviment forms inside forms-container
            this.y = event.screenY - this.startY;
            this.x = event.screenX - this.startX;
            
            this.model.x = this.x;
            this.model.y = this.y;

            this.updateStyles();
        }

        document.removeEventListener('drop', this.bindTouchEnd, true);
    }

    updateStyles(){
        this.styles = {
            'position': 'absolute',
            'top': `${this.model.y}px`,
            'left': `${this.model.x}px`,
            'width': `${this.model.width}px`,
            'heigth': `${this.model.heigth}px`,
            'transform': `rotate( ${ this.model.angle }deg )`,
        }
    }
    
}


// WEBPACK FOOTER //
// ./src/app/components/ui/stage-puzzleform/stage-puzzleform.controller.js